import { setOptions, importLibrary } from "@googlemaps/js-api-loader";
const ModuleName = 'OnDemandPortal';
const DefaultZoom = 15;
const DefaultZoomForPan = 15;
export class InitialiseMapArgs {
}
export class MapStore {
}
export class MapDriver {
}
export class MapOrder {
}
export var MapClusterPolygonsModeEnum;
(function (MapClusterPolygonsModeEnum) {
    MapClusterPolygonsModeEnum[MapClusterPolygonsModeEnum["Polygons_Off"] = 0] = "Polygons_Off";
    MapClusterPolygonsModeEnum[MapClusterPolygonsModeEnum["Polygons_On"] = 1] = "Polygons_On";
})(MapClusterPolygonsModeEnum || (MapClusterPolygonsModeEnum = {}));
export var MapLiveTrafficModeEnum;
(function (MapLiveTrafficModeEnum) {
    MapLiveTrafficModeEnum[MapLiveTrafficModeEnum["Live_Traffic_Off"] = 0] = "Live_Traffic_Off";
    MapLiveTrafficModeEnum[MapLiveTrafficModeEnum["Live_Traffic_On"] = 1] = "Live_Traffic_On";
})(MapLiveTrafficModeEnum || (MapLiveTrafficModeEnum = {}));
class GoogleMapsPingoMapService {
    constructor() {
        this.ClassName = "GoogleMapsPingoMapService";
        this._MapStoreAdvancedMarkerElements = [];
        this._MapDriverAdvancedMarkerElements = [];
        this._MapOrderAdvancedMarkerElements = [];
        // Private Methods END
    }
    async mapInitialiseAsync(mapInitialiseArgs) {
        const methodName = `${this.ClassName}.mapInitialiseAsync`;
        console.log(`METHOD ${methodName}| STARTED`);
        if (mapInitialiseArgs == null) {
            console.log(`METHOD ${methodName}| mapInitialiseArgs is NULL or UNDEFINED!`);
            return;
        }
        if (mapInitialiseArgs.apiKey == null) {
            console.log(`METHOD ${methodName}| mapInitialiseArgs.apiKey is NULL or UNDEFINED!`);
            return;
        }
        if (mapInitialiseArgs.mapIds == null) {
            console.log(`METHOD ${methodName}| mapInitialiseArgs.mapIds is NULL or UNDEFINED!`);
            return;
        }
        console.log(`METHOD ${methodName}| elementId:`, mapInitialiseArgs.elementId);
        //TODO: REMOVE once testing finished!:
        console.log(`METHOD ${methodName}| apiKey:`, mapInitialiseArgs.apiKey);
        //TODO: REMOVE once testing finished!:
        console.log(`METHOD ${methodName}| mapIds:`, JSON.stringify(mapInitialiseArgs.mapIds));
        console.log(`METHOD ${methodName}| mapIds:`, JSON.stringify(mapInitialiseArgs.polygon));
        setOptions({ key: mapInitialiseArgs.apiKey, mapIds: mapInitialiseArgs.mapIds });
        await importLibrary("core");
        await importLibrary("maps"); // needed for <gmp-map>
        await importLibrary("marker"); // needed for <gmp-advanced-marker>
        await customElements.whenDefined("gmp-map");
        const center = { lat: mapInitialiseArgs.latitude ?? 0, lng: mapInitialiseArgs.longitude ?? 0 };
        if (this._Map != null) {
            this._Map.unbindAll();
        }
        this._Map = new google.maps.Map(document.getElementById(mapInitialiseArgs.elementId ?? ""), {
            mapId: mapInitialiseArgs.mapIds[0],
            center,
            zoom: mapInitialiseArgs.zoom ?? DefaultZoom,
            gestureHandling: "greedy",
            zoomControl: false,
            mapTypeControl: false,
            streetViewControl: false, // This hides the Pegman control
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            fullscreenControl: false,
            noClear: true,
            clickableIcons: true
        });
        if (mapInitialiseArgs.mapLiveTrafficModeEnum != null) {
            await this.mapLiveTrafficModeEnumSet(mapInitialiseArgs.mapLiveTrafficModeEnum);
        }
        if (mapInitialiseArgs.polygon != null) {
            this._Polygon = mapInitialiseArgs.polygon;
        }
        if (mapInitialiseArgs.mapClusterPolygonsModeEnum != null) {
            await this.mapClusterPolygonsModeEnumSet(mapInitialiseArgs.mapClusterPolygonsModeEnum);
        }
        // Add any other map initialization logic here
    }
    async mapClusterPolygonsModeEnumSet(mapClusterPolygonsModeEnum) {
        const methodName = `${this.ClassName}.mapClusterPolygonsModeEnumSet`;
        console.log(`METHOD ${methodName}| STARTED`);
        switch (mapClusterPolygonsModeEnum) {
            case MapClusterPolygonsModeEnum.Polygons_On:
                await this.storeMapPolygonsSetAsync(this._Polygon);
                console.log(`METHOD ${methodName}| Turned Polygons ON`);
                break;
            case MapClusterPolygonsModeEnum.Polygons_Off:
                await this.storeMapPolygonsRemoveAsync();
                console.log(`METHOD ${methodName}| Turned Polygons OFF`);
                break;
        }
        console.log(`METHOD ${methodName}| FINISHED`);
    }
    async storeMapPolygonsSetAsync(polygon) {
        const methodName = `${this.ClassName}.storeMapPolygonsSetAsync`;
        console.log(`METHOD ${methodName}| STARTED`);
        console.log(`METHOD ${methodName}| Polygon:`, JSON.stringify(polygon));
        try {
            await this.storeMapPolygonsRemoveAsync();
            if (polygon.length > 0) {
                const geoJson = {
                    type: 'FeatureCollection',
                    features: [
                        {
                            type: 'Feature',
                            properties: {
                                name: 'Store Polygon',
                            },
                            geometry: {
                                type: 'Polygon',
                                coordinates: [
                                    polygon,
                                ],
                            },
                        },
                    ],
                };
                console.log(`METHOD ${methodName}| geoJson:`, JSON.stringify(geoJson));
                this._MapStoreDataFeatures = this._Map.data.addGeoJson(geoJson);
                // const style = {
                const stroke = true;
                const color = "#61ade0";
                const opacity = 0.8;
                const fillOpacity = 0.2;
                const weight = 3;
                // };
                if (stroke) {
                    this._Map.data.setStyle({
                        fillColor: color,
                        strokeColor: color,
                        strokeWeight: weight,
                        opacity: opacity,
                        fillOpacity: fillOpacity,
                        draggable: false,
                        clickable: false,
                        editable: false
                    });
                }
            }
        }
        catch (e) {
            console.warn(`METHOD ${methodName}| ERROR:`, e);
        }
        console.log(`${methodName} FINISHED`);
    }
    async storeMapPolygonsRemoveAsync() {
        const methodName = `${this.ClassName}.storeMapPolygonsRemoveAsync`;
        console.log(`METHOD ${methodName}| STARTED`);
        //debugger;
        if (this._Map == null) {
            console.log(`METHOD ${methodName}| _Map is NOT created so exiting early !!!`);
            return;
        }
        try {
            if (this._MapStoreDataFeatures != null) {
                const currentMapStoreDataFeatures = this._MapStoreDataFeatures.filter(f => f.getId() == f.getId());
                for (const feature of currentMapStoreDataFeatures) {
                    this._Map.data.remove(feature);
                }
                this._MapStoreDataFeatures = undefined;
            }
        }
        catch (e) {
            console.warn(`METHOD ${methodName}| ERROR:`, e);
        }
        console.log(`METHOD ${methodName}| FINISHED`);
    }
    async mapLiveTrafficModeEnumSet(mapLiveTrafficModeEnum) {
        const methodName = `${this.ClassName}.mapLiveTrafficModeEnumSet`;
        console.log(`METHOD ${methodName}| STARTED`);
        if (this._TrafficLayer == null) {
            this._TrafficLayer = new google.maps.TrafficLayer();
            console.log(`METHOD ${methodName}| Set TrafficLayer`);
        }
        switch (mapLiveTrafficModeEnum) {
            case MapLiveTrafficModeEnum.Live_Traffic_On:
                this._TrafficLayer.setMap(this._Map);
                console.log(`METHOD ${methodName}| Turned Live Traffic ON`);
                break;
            case MapLiveTrafficModeEnum.Live_Traffic_Off:
                this._TrafficLayer.setMap(null);
                console.log(`METHOD ${methodName}| Turned Live Traffic OFF`);
                break;
        }
        console.log(`METHOD ${methodName}| FINISHED`);
    }
    async mapStoreSetAsync(mapStore) {
        const methodName = `${this.ClassName}.mapStoreSetAsync`;
        console.log(`METHOD ${methodName}| STARTED`);
        try {
            if (mapStore == null) {
                console.log(`METHOD ${methodName}| mapStore is NULL or UNDEFINED!`);
                return;
            }
            if (this._Map == null) {
                console.log(`METHOD ${methodName}| _Map is NOT created so exiting early !!!`);
                return;
            }
            if (mapStore.id == null) {
                console.log(`METHOD ${methodName}| mapStore.id is null so exiting early !!!`);
                return;
            }
            if (mapStore.imageUrl == null) {
                console.log(`METHOD ${methodName}| mapStore.imageUrl is null so exiting early !!!`);
                return;
            }
            const mapStoreAdvancedMarkerContentElement = this.createAdvancedMarkerContent(mapStore.imageUrl, 20, 20, "transparent", "", "1", "1");
            const mapStoreAdvancedMarkerElements = this._MapStoreAdvancedMarkerElements.filter(f => f.title === mapStore.id);
            if (mapStoreAdvancedMarkerElements != null && mapStoreAdvancedMarkerElements.length > 0) {
                const mapStoreAdvancedMarkerElement = mapStoreAdvancedMarkerElements[0];
                mapStoreAdvancedMarkerElement.content = mapStoreAdvancedMarkerContentElement;
                // this._MapStoreAdvancedMarkerElements.set(mapStore.id, storeAdvancedMarkerElement);
            }
            else {
                const storeCoordinates = { lat: mapStore.latitude ?? 0, lng: mapStore.longitude ?? 0 };
                console.log(`METHOD ${methodName}| storeCoordinates`, JSON.stringify(storeCoordinates));
                const mapStoreAdvancedMarkerElement = new google.maps.marker.AdvancedMarkerElement({
                    map: this._Map,
                    position: storeCoordinates,
                    title: mapStore.id,
                    content: mapStoreAdvancedMarkerContentElement
                });
                const infoWindow = new google.maps.InfoWindow({
                    content: `<div id='store_popup_${mapStore.id}' style="color: black; padding-top: 0; z-index: 1000;"><b>${mapStore.name}</b></div>`,
                });
                const map = this._Map;
                mapStoreAdvancedMarkerElement.addListener('click', () => {
                    infoWindow.open({
                        anchor: mapStoreAdvancedMarkerElement,
                        map
                    });
                    // if (mapStore.id != null) {
                    this._MapStoreAdvancedMarkerElements.push(mapStoreAdvancedMarkerElement);
                    // }
                });
                if (mapStore.mustPanTo ?? false) {
                    console.warn(`METHOD ${methodName}| 2 PANNING to Marker position`);
                    this._Map.setCenter(storeCoordinates);
                    this._Map.setZoom(DefaultZoomForPan);
                    console.warn(`METHOD ${methodName}| 2 PANNED to Marker position`);
                }
                console.log(`METHOD ${methodName}| Added Store Marker for ${mapStore.name}!`);
            }
        }
        catch (e) {
            console.warn(`METHOD ${methodName}| ERROR:`, e);
        }
        console.log(`METHOD ${methodName}| FINISHED`);
    }
    async mapStoreRemoveAsync(mapStoreId) {
        const methodName = `${this.ClassName}.mapStoreRemoveAsync`;
        console.log(`METHOD ${methodName}| STARTED`);
        try {
            if (mapStoreId == null) {
                console.log(`METHOD ${methodName}| mapStoreId is NULL or UNDEFINED!`);
                return;
            }
            if (this._Map == null) {
                console.log(`METHOD ${methodName}| _Map is NOT created so exiting early !!!`);
                return;
            }
            const storeAdvancedMarkerElements = this._MapStoreAdvancedMarkerElements.filter(f => f.title === mapStoreId);
            if (storeAdvancedMarkerElements != null && storeAdvancedMarkerElements.length > 0) {
                const storeAdvancedMarkerElement = storeAdvancedMarkerElements[0];
                storeAdvancedMarkerElement.map = null;
            }
        }
        catch (e) {
            console.warn(`METHOD ${methodName}| ERROR:`, e);
        }
    }
    async removeMapStoresAllAsync() {
        const methodName = `${this.ClassName}.removeMapStoresAllAsync`;
        console.log(`METHOD ${methodName}| STARTED`);
        try {
            if (this._Map == null) {
                console.log(`METHOD ${methodName}| _Map is NOT created so exiting early !!!`);
                return;
            }
            if (this._MapStoreAdvancedMarkerElements.length > 0) {
                const currentMapStoreAdvancedMarkerElements = this._MapStoreAdvancedMarkerElements.filter(f => f.id == f.id);
                for (const mapDriverAdvancedMarkerElement of currentMapStoreAdvancedMarkerElements) {
                    mapDriverAdvancedMarkerElement.map = null;
                }
                console.log(`METHOD ${methodName}| AFTER| MapStores successfully removed`);
            }
        }
        catch (e) {
            console.warn(`METHOD ${methodName}| ERROR:`, e);
        }
    }
    // private sleep(ms: number): Promise<void> {
    //   return new Promise((resolve) => setTimeout(resolve, ms));
    // }
    processValue(input) {
        let result = 0;
        if (typeof input === 'function') {
            // Now TypeScript knows 'input' is a function, so it can be called
            result = input();
            console.log("Function result:", result);
        }
        else {
            // 'input' is a number
            result = input;
        }
        return result;
    }
    async mapDriverSetAsync(mapDriver) {
        const methodName = `${this.ClassName}.mapDriverSetAsync`;
        console.log(`METHOD ${methodName}| STARTED`);
        try {
            console.log(`METHOD ${methodName}| driver:`, JSON.stringify(mapDriver));
            if (this._Map == null) {
                console.log(`METHOD ${methodName}| _Map is NOT created so exiting early !!!`);
                return;
            }
            if (mapDriver.id == null) {
                console.log(`METHOD ${methodName}| _Map.id is NOT created so exiting early !!!`);
                return;
            }
            if (mapDriver.longitude && mapDriver.longitude == 0 || mapDriver.latitude && mapDriver.latitude == 0) {
                console.log(`METHOD ${methodName}| longitude or latitude is 0 therefore cannot set driver on map!`);
                return;
            }
            if (mapDriver.imageUrl == null) {
                console.warn(`METHOD ${methodName}| ERROR: cannot call this private with a NULL imageUrl so exiting early !!!`);
                return;
            }
            console.log(`METHOD ${methodName}| BEFORE this._MapDriverAdvancedMarkerElements.length : ${this._MapDriverAdvancedMarkerElements.length}`);
            console.log(`METHOD ${methodName}| BEFORE this._MapDriverAdvancedMarkerElements : ${this._MapDriverAdvancedMarkerElements}`);
            let title = mapDriver.appName ?? "Unknown App";
            title = mapDriver.orderId ? `${title} - Store ${mapDriver.orderStoreCode}` : title;
            title = mapDriver.orderAddress ? `${title} - Deliver to ${mapDriver.orderAddress}` : title;
            const mapDriverCoordinates = { lat: mapDriver.latitude ?? 0, lng: mapDriver.longitude ?? 0 };
            const mapDriverAdvancedMarkerContentElement = this.createAdvancedMarkerContent(mapDriver.imageUrl, 40, 40, "black", mapDriver.id, "0.8", "0.2");
            // let mapDriverAdvancedMarkerElement = this._MapDriverAdvancedMarkerElements.get(mapDriver.id)
            console.log(`METHOD ${methodName}| CALLING this._MapDriverAdvancedMarkerElements.filter(f => f.title === ${mapDriver.id});`);
            const mapDriverAdvancedMarkerElements = this._MapDriverAdvancedMarkerElements.filter(f => f.title === mapDriver.id);
            console.log(`METHOD ${methodName}| CALLED this._MapDriverAdvancedMarkerElements.filter(f => f.title === ${mapDriver.id});`);
            console.log(`METHOD ${methodName}| mapDriverAdvancedMarkerElements: ${mapDriverAdvancedMarkerElements}`);
            const map = this._Map;
            if (mapDriverAdvancedMarkerElements != null && mapDriverAdvancedMarkerElements.length > 0) {
                for (const mapDriverAdvancedMarkerElement of mapDriverAdvancedMarkerElements) {
                    console.log(`METHOD ${methodName}| mapDriverAdvancedMarkerElement: ${mapDriverAdvancedMarkerElement}`);
                    mapDriverAdvancedMarkerElement.content = mapDriverAdvancedMarkerContentElement;
                    mapDriverAdvancedMarkerElement.map = map;
                    if (mapDriverAdvancedMarkerElement.position != null) {
                        console.log(`METHOD ${methodName}| MarkerWithLabel for ${mapDriver.id} does NOT exist so creating it`);
                        const currentPosition = { lat: this.processValue(mapDriverAdvancedMarkerElement.position.lat) ?? 0, lng: this.processValue(mapDriverAdvancedMarkerElement.position.lng) ?? 0 };
                        const path = this.generateMeterSpacedPoints(currentPosition, mapDriverCoordinates);
                        for (const latLngLiteral of path) {
                            mapDriverAdvancedMarkerElement.position = latLngLiteral;
                            // this.sleep(1);
                        }
                    }
                    else {
                        mapDriverAdvancedMarkerElement.position = mapDriverCoordinates;
                    }
                }
            }
            else {
                console.log(`METHOD ${methodName}| MarkerWithLabel for ${mapDriver.id} does NOT exist so creating it`);
                const mapDriverAdvancedMarkerElement = new google.maps.marker.AdvancedMarkerElement({
                    map: this._Map,
                    position: mapDriverCoordinates,
                    title: mapDriver.id,
                    content: mapDriverAdvancedMarkerContentElement
                });
                const infoWindow = new google.maps.InfoWindow({
                    content: `<div id='driver_popup_${mapDriver.id}' style="color: black; padding-top: 0; z-index: 1000;"><b title='${title}' id='add_driver_html_${mapDriver.id}'>${mapDriver.name} (${mapDriver.appName?.replace("_", " ")})</b></div>`,
                });
                mapDriverAdvancedMarkerElement.addListener('click', () => {
                    infoWindow.open({
                        anchor: mapDriverAdvancedMarkerElement,
                        map
                    });
                });
                console.log(`METHOD ${methodName}| CALLING this._MapDriverAdvancedMarkerElements.push(${mapDriverAdvancedMarkerElement});`);
                this._MapDriverAdvancedMarkerElements.push(mapDriverAdvancedMarkerElement);
                console.log(`METHOD ${methodName}| CALLED this._MapDriverAdvancedMarkerElements.push(${mapDriverAdvancedMarkerElement});`);
            }
            console.log(`METHOD ${methodName}| Created driver marker for driver ID: ${mapDriver.id}, Order ID: ${mapDriver.orderId}`);
            if (mapDriver.mustPanTo ?? false) {
                console.warn(`METHOD ${methodName}| 2 PANNING to Marker position`);
                this._Map.setCenter(mapDriverCoordinates);
                // this._Map.setZoom(DefaultZoomForPan);
                console.warn(`METHOD ${methodName}| 2 PANNED to Marker position`);
            }
            console.log(`METHOD ${methodName}| AFTER this._MapDriverAdvancedMarkerElements.length : ${this._MapDriverAdvancedMarkerElements.length}`);
            console.log(`METHOD ${methodName}| AFTER this._MapDriverAdvancedMarkerElements : ${this._MapDriverAdvancedMarkerElements}`);
        }
        catch (e) {
            console.warn(`METHOD ${methodName}| 2 ERROR:`, e);
        }
        console.log(`METHOD ${methodName}| FINISHED`);
    }
    async mapDriversSetAsync(mapDrivers) {
        const methodName = `${this.ClassName}.mapDriversSetAsync`;
        console.log(`METHOD ${methodName}| STARTED`);
        try {
            console.log(`METHOD ${methodName}| drivers:`, JSON.stringify(mapDrivers));
            for (const mapDriver of mapDrivers) {
                await this.mapDriverSetAsync(mapDriver);
            }
        }
        catch (e) {
            console.warn(`METHOD ${methodName}| ERROR:`, e);
        }
        console.log(`METHOD ${methodName}| FINISHED`);
    }
    async mapDriversRemoveAsync(mapDriverIds) {
        const methodName = `${this.ClassName}.removeMapDriverAsync`;
        console.log(`METHOD ${methodName}| STARTED`);
        try {
            if (mapDriverIds == null) {
                console.log(`METHOD ${methodName}| mapDriverId is NULL or UNDEFINED!`);
                return;
            }
            if (this._Map == null) {
                console.log(`METHOD ${methodName}| _Map is NOT created so exiting early !!!`);
                return;
            }
            console.log(`METHOD ${methodName}| this._MapDriverAdvancedMarkerElements :`, this._MapDriverAdvancedMarkerElements);
            console.log(`METHOD ${methodName}| mapDriverIds :`, mapDriverIds);
            for (const mapDriverId in mapDriverIds) {
                const filteredMapDriverAdvancedMarkerElements = this._MapDriverAdvancedMarkerElements.filter(f => f.title === mapDriverId);
                console.log(`METHOD ${methodName}| filteredMapDriverAdvancedMarkerElements :`, filteredMapDriverAdvancedMarkerElements);
                if (filteredMapDriverAdvancedMarkerElements != null && filteredMapDriverAdvancedMarkerElements.length > 0) {
                    console.log(`METHOD ${methodName}| filteredMapDriverAdvancedMarkerElements IS NOT NULL or UNDEFINED`);
                    for (const mapDriverAdvancedMarkerElement of filteredMapDriverAdvancedMarkerElements) {
                        console.log(`METHOD ${methodName}| mapDriverAdvancedMarkerElement: ${mapDriverAdvancedMarkerElement}`);
                        console.log(`METHOD ${methodName}| CALLING index: mapDriverAdvancedMarkerElement.map = null;`);
                        mapDriverAdvancedMarkerElement.map = null;
                        console.log(`METHOD ${methodName}| CALLED index: mapDriverAdvancedMarkerElement.map = null;`);
                    }
                }
            }
            console.log(`METHOD ${methodName}| AFTER: this._MapDriverAdvancedMarkerElements.length :`, this._MapDriverAdvancedMarkerElements.length);
            console.log(`METHOD ${methodName}| AFTER: SpecifiedMapDrivers successfully removed`);
        }
        catch (e) {
            console.warn(`METHOD ${methodName}| ERROR:`, e);
        }
    }
    async mapDriversRemoveAllAsync() {
        const methodName = `${this.ClassName}.mapDriversRemoveAllAsync`;
        console.log(`METHOD ${methodName}| STARTED`);
        try {
            if (this._Map == null) {
                console.log(`METHOD ${methodName}| _Map is NOT created so exiting early !!!`);
                return;
            }
            if (this._MapDriverAdvancedMarkerElements.length > 0) {
                const currentMapDriverAdvancedMarkerElements = this._MapDriverAdvancedMarkerElements.filter(f => f.id === f.id);
                for (const mapDriverAdvancedMarkerElement of currentMapDriverAdvancedMarkerElements) {
                    console.log(`METHOD ${methodName}| mapDriverAdvancedMarkerElement: ${mapDriverAdvancedMarkerElement}`);
                    console.log(`METHOD ${methodName}| CALLING mapDriverAdvancedMarkerElement.map = null;`);
                    mapDriverAdvancedMarkerElement.map = null;
                    console.log(`METHOD ${methodName}| CALLED mapDriverAdvancedMarkerElement.map = null;`);
                }
            }
        }
        catch (e) {
            console.warn(`METHOD ${methodName}| ERROR:`, e);
        }
    }
    async mapOrderSetAsync(mapOrder) {
        const methodName = `${this.ClassName}.mapOrderSetAsync`;
        console.log(`METHOD ${methodName}| STARTED`);
        console.warn('mapOrder:', JSON.stringify(mapOrder));
        try {
            if (this._Map == null) {
                console.warn(`METHOD ${methodName}| WARNING: _Map is not initialised so exiting early !!!`);
                return;
            }
            if (mapOrder == null) {
                console.warn(`METHOD ${methodName}| ERROR: cannot call this private with a NULL mapOrder so exiting early !!!`);
                return;
            }
            if (mapOrder.id == null) {
                console.warn(`METHOD ${methodName}| ERROR: cannot call this private with a NULL id so exiting early !!!`);
                return;
            }
            if (mapOrder.longitude == null) {
                console.warn(`METHOD ${methodName}| ERROR: cannot call this private with a NULL longitude so exiting early !!!`);
                return;
            }
            if (mapOrder.latitude == null) {
                console.warn(`METHOD ${methodName}| ERROR: cannot call this private with a NULL latitude so exiting early !!!`);
                return;
            }
            if (mapOrder.longitude == 0 || mapOrder.latitude == 0) {
                console.warn(`METHOD ${methodName}| longitude or latitude is 0 therefore cannot set driver on map!`);
                return;
            }
            if (mapOrder.latitude < -90 || mapOrder.latitude > 90) {
                console.warn(`METHOD ${methodName}| latitude is either less than -90 or greater than 90 therefore cannot set driver on map!`);
                return;
            }
            if (mapOrder.imageUrl == null) {
                console.warn(`METHOD ${methodName}| ERROR: cannot call this private with a NULL imageUrl so exiting early !!!`);
                return;
            }
            if (mapOrder.mapOrderType == null) {
                console.warn(`METHOD ${methodName}| ERROR: cannot call this private with a NULL mapOrderType so exiting early !!!`);
                return;
            }
            let pinText = "";
            if (mapOrder.tag || mapOrder.pinText) {
                pinText = mapOrder.tag;
                if (mapOrder.pinText != null && mapOrder.pinText.length > 0) {
                    if (pinText != null && pinText.length > 0) {
                        pinText = `${pinText} ${mapOrder.pinText}`;
                    }
                    else {
                        pinText = `${mapOrder.pinText}`;
                    }
                }
                if (pinText == null) {
                    pinText = "UNKNOWN!";
                }
            }
            console.log(`METHOD ${methodName}| BEFORE| this._MapOrderAdvancedMarkerElements.length: ${this._MapOrderAdvancedMarkerElements.length}`);
            const mapOrderCoordinates = { lat: mapOrder.latitude ?? 0, lng: mapOrder.longitude ?? 0 };
            const mapOrderAdvancedMarkerContentHTMLElement = this.createAdvancedMarkerContent(mapOrder.imageUrl, 20, 20, "var(--pingoMint)", pinText, "1", "1");
            const map = this._Map;
            const mapOrderAdvancedMarkerElements = this._MapOrderAdvancedMarkerElements.filter(f => f.title === mapOrder.id);
            if (mapOrderAdvancedMarkerElements != null && mapOrderAdvancedMarkerElements.length > 0) {
                console.log(`METHOD ${methodName}| MarkerWithLabel(s) for ${mapOrder.id} does ALREADY exist so updating its content!`);
                for (const mapOrderAdvancedMarkerElement of mapOrderAdvancedMarkerElements) {
                    mapOrderAdvancedMarkerElement.content = mapOrderAdvancedMarkerContentHTMLElement;
                    mapOrderAdvancedMarkerElement.map = map;
                    mapOrderAdvancedMarkerElement.position = mapOrderCoordinates;
                }
            }
            else {
                console.log(`METHOD ${methodName}| MarkerWithLabel for ${mapOrder.id} does NOT exist so creating it`);
                const mapOrderAdvancedMarkerElement = new google.maps.marker.AdvancedMarkerElement({
                    map: this._Map,
                    position: mapOrderCoordinates,
                    title: mapOrder.id,
                    content: mapOrderAdvancedMarkerContentHTMLElement
                });
                const infoWindow = new google.maps.InfoWindow({
                    content: "<div id='orderpp_" + mapOrder.id + "' style='color: black; padding-top: 0; z-index: 1000;'><b>" + mapOrder.id + "</b><div>",
                });
                mapOrderAdvancedMarkerElement.addListener('click', () => {
                    infoWindow.open({
                        anchor: mapOrderAdvancedMarkerElement,
                        map
                    });
                });
                this._MapOrderAdvancedMarkerElements.push(mapOrderAdvancedMarkerElement);
                console.log(`METHOD ${methodName}| Created order marker for Order ID: ${mapOrder.id}`);
            }
            console.log(`METHOD ${methodName}| AFTER| this._MapOrderAdvancedMarkerElements.length: ${this._MapOrderAdvancedMarkerElements.length}`);
            if (mapOrder.mustPanTo ?? false) {
                console.warn(`METHOD ${methodName}| 2 PANNING to Marker position`);
                this._Map.setCenter(mapOrderCoordinates);
                // this._Map.setZoom(DefaultZoomForPan);
                console.warn(`METHOD ${methodName}| 2 PANNED to Marker position`);
            }
            console.log(`METHOD ${methodName}| Created order marker for order ID: ${mapOrder.id}, Order ID: ${mapOrder.id}`);
        }
        catch (e) {
            console.warn(`METHOD ${methodName}| ERROR:`, e);
        }
        console.log(`METHOD ${methodName}| FINISHED`);
    }
    async mapOrdersSetAsync(mapOrders) {
        const methodName = `${this.ClassName}.mapOrdersSetAsync`;
        console.log(`METHOD ${methodName}| STARTED`);
        try {
            console.log(`METHOD ${methodName}| drivers:`, mapOrders);
            for (const mapOrder of mapOrders) {
                await this.mapOrderSetAsync(mapOrder);
            }
        }
        catch (e) {
            console.warn(`METHOD ${methodName}| ERROR:`, e);
        }
        console.log(`METHOD ${methodName}| FINISHED`);
    }
    async mapOrdersRemoveAsync(mapOrderIds) {
        const methodName = `${this.ClassName}.removeMapOrderAsync`;
        console.log(`METHOD ${methodName}| STARTED`);
        try {
            if (mapOrderIds == null) {
                console.log(`METHOD ${methodName}| mapOrderIds is NULL or UNDEFINED!`);
                return;
            }
            if (this._Map == null) {
                console.log(`METHOD ${methodName}| _Map is NOT created so exiting early !!!`);
                return;
            }
            for (const mapOrderId of mapOrderIds) {
                const mapOrderAdvancedMarkerElements = this._MapOrderAdvancedMarkerElements.filter(f => f.title === mapOrderId);
                if (mapOrderAdvancedMarkerElements != null && mapOrderAdvancedMarkerElements.length > 0) {
                    for (const mapOrderAdvancedMarkerElement of mapOrderAdvancedMarkerElements) {
                        mapOrderAdvancedMarkerElement.map = null;
                    }
                }
            }
        }
        catch (e) {
            console.warn(`METHOD ${methodName}| ERROR:`, e);
        }
    }
    async mapOrdersRemoveAllAsync( /*mapOrderType: string*/) {
        const methodName = `${this.ClassName}.mapOrdersRemoveAllAsync`;
        console.log(`METHOD ${methodName}| STARTED`);
        try {
            if (this._Map == null) {
                console.log(`METHOD ${methodName}| _Map is NOT created so exiting early !!!`);
                return;
            }
            const currentMapOrderAdvancedMarkerElements = this._MapOrderAdvancedMarkerElements.filter(f => f.id == f.id);
            if (currentMapOrderAdvancedMarkerElements.length > 0) {
                for (const mapOrderAdvancedMarkerElement of currentMapOrderAdvancedMarkerElements) {
                    mapOrderAdvancedMarkerElement.map = null;
                }
                console.log(`METHOD ${methodName}| AFTER| MapOrders successfully removed`);
            }
        }
        catch (e) {
            console.warn(`METHOD ${methodName}| ERROR:`, e);
        }
    }
    // Private Methods START
    /*START
    * GPS location calculation code
    * */
    /**
     * Calculates the great-circle distance between two points in meters
     */
    haversineDistance(point1, point2) {
        const R = 6371000; // Earth's radius in meters
        const toRad = (deg) => (deg * Math.PI) / 180;
        const lat1 = toRad(point1.lat);
        const lat2 = toRad(point2.lat);
        const deltaLat = toRad(point2.lat - point1.lat);
        const deltaLng = toRad(point2.lng - point1.lng);
        const a = Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
            Math.cos(lat1) * Math.cos(lat2) *
                Math.sin(deltaLng / 2) * Math.sin(deltaLng / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    }
    /**
     * Returns the destination point given start point, distance, and bearing
     */
    destinationPoint(point, distance, bearing) {
        const R = 6371000; // Earth's radius in meters
        const toRad = (deg) => (deg * Math.PI) / 180;
        const toDeg = (rad) => (rad * 180) / Math.PI;
        const lat1 = toRad(point.lat);
        const lng1 = toRad(point.lng);
        const angularDistance = distance / R;
        const lat2 = Math.asin(Math.sin(lat1) * Math.cos(angularDistance) +
            Math.cos(lat1) * Math.sin(angularDistance) * Math.cos(toRad(bearing)));
        const lng2 = lng1 +
            Math.atan2(Math.sin(toRad(bearing)) * Math.sin(angularDistance) * Math.cos(lat1), Math.cos(angularDistance) - Math.sin(lat1) * Math.sin(lat2));
        return {
            lat: toDeg(lat2),
            lng: toDeg(lng2),
        };
    }
    /**
     * Calculates the initial bearing from point1 to point2
     */
    calculateBearing(point1, point2) {
        const toRad = (deg) => (deg * Math.PI) / 180;
        const toDeg = (rad) => (rad * 180) / Math.PI;
        const lat1 = toRad(point1.lat);
        const lat2 = toRad(point2.lat);
        const deltaLng = toRad(point2.lng - point1.lng);
        const y = Math.sin(deltaLng) * Math.cos(lat2);
        const x = Math.cos(lat1) * Math.sin(lat2) -
            Math.sin(lat1) * Math.cos(lat2) * Math.cos(deltaLng);
        const bearing = toDeg(Math.atan2(y, x));
        return (bearing + 360) % 360; // Normalize to 0-360
    }
    /**
     * Generates GPS points every meter between two locations
     */
    generateMeterSpacedPoints(start, end) {
        const methodName = `${this.ClassName}.generateMeterSpacedPoints`;
        const points = [];
        const totalDistance = this.haversineDistance(start, end);
        // // If points are the same or very close, return just the start
        // if (totalDistance < 0.01) {
        //   console.log(`METHOD ${methodName}| ${totalDistance} < 0.01 so exiting EARLY`);
        //   return [start];
        // }
        // console.log(`METHOD ${methodName}| ${totalDistance} is NOT < 0.01 so so calculating in-between locations`);
        const bearing = this.calculateBearing(start, end);
        const numPoints = Math.floor(totalDistance); // One point per meter
        points.push({ ...start }); // Include start point
        for (let d = 1; d <= numPoints; d++) {
            const point = this.destinationPoint(start, d, bearing);
            points.push({
                lat: parseFloat(point.lat.toFixed(10)),
                lng: parseFloat(point.lng.toFixed(10)),
            });
        }
        // Ensure end point is included (due to floating point precision)
        const lastPoint = points[points.length - 1];
        if (Math.abs(lastPoint.lat - end.lat) > 1e-8 ||
            Math.abs(lastPoint.lng - end.lng) > 1e-8) {
            points.push({ ...end });
        }
        console.log(`METHOD ${methodName}| return ${JSON.stringify(points)}`);
        return points;
    }
    /*END
    * GPS location calculation code
    * */
    /**
     * Creates a custom HTMLElement for use as content in google.maps.marker.AdvancedMarkerElement.
     * Features:
     * - 40x40 image
     * - Text label below image, wrapped within 40px width
     * - Black background with white text
     *
     * @param imageSrc - URL of the image to display
     * @param imageWidth
     * @param imageHeight
     * @param labelBackgroundColour
     * @param labelText - Text to display below the image (will wrap)
     * @param opacity
     * @param fillOpacity
     * @returns HTMLElement ready for AdvancedMarkerElement.content
     */
    createAdvancedMarkerContent(imageSrc, imageWidth, imageHeight, labelBackgroundColour, labelText, opacity, fillOpacity) {
        const methodName = `${this.ClassName}.createAdvancedMarkerContent`;
        console.log(`METHOD ${methodName}| STARTED`);
        console.log(`METHOD ${methodName}| imageSrc : ${imageSrc}`);
        console.log(`METHOD ${methodName}| labelText : ${labelText}`);
        console.log(`METHOD ${methodName}| opacity : ${opacity}`);
        console.log(`METHOD ${methodName}| fillOpacity : ${fillOpacity}`);
        const container = document.createElement('div');
        container.style.display = 'flex';
        container.style.flexDirection = 'column';
        container.style.alignItems = 'center';
        container.style.width = `${imageWidth}px`;
        container.style.pointerEvents = 'none'; // don’t block map clicks
        // ----- Image (always present) -----
        const img = document.createElement('img');
        img.src = imageSrc;
        img.alt = labelText?.trim() || 'Marker';
        img.width = imageWidth;
        img.height = imageHeight;
        img.style.objectFit = 'contain';
        img.style.display = 'block';
        img.style.opacity = opacity ?? "1";
        img.style.fillOpacity = fillOpacity ?? "1";
        container.appendChild(img);
        // ----- Label (only if text exists) -----
        const text = labelText?.trim();
        console.log(`METHOD ${methodName}| text : ${text}`);
        if (text) {
            const label = document.createElement('div');
            label.textContent = text;
            label.style.width = `40px`;
            label.style.padding = '2px 4px';
            label.style.backgroundColor = `${labelBackgroundColour}`;
            label.style.color = '#fff';
            label.style.fontFamily = 'var(font-family)';
            label.style.fontSize = 'var(--pingo-font-size)';
            label.style.fontWeight = '500';
            label.style.textAlign = 'center';
            label.style.lineHeight = '1.2';
            label.style.overflowWrap = 'break-word';
            label.style.whiteSpace = 'normal';
            label.style.boxSizing = 'border-box';
            label.style.borderRadius = '2px';
            label.style.marginTop = '2px';
            container.appendChild(label);
        }
        return container;
    }
}
export default GoogleMapsPingoMapService;
export function createMapService() {
    const methodName = `${ModuleName}.createMapService`;
    let result;
    try {
        console.log(`METHOD ${methodName}| STARTED`);
        result = new GoogleMapsPingoMapService();
        console.log(`METHOD ${methodName}| GoogleMapsPingoMapService successfully created: ${JSON.stringify(result)}`);
    }
    catch (e) {
        console.warn(`METHOD ${methodName}| ERROR:`, e);
    }
    return result;
}
